import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import CardGroup from "react-bootstrap/CardGroup";
import Button from "react-bootstrap/Button";
import ResidentialImage from "../assets/Services_Photo.png";
import BusinessImage from "../assets/Services_Photo-1.png";
import CustomImage from "../assets/Services_Photo-2.png";
import "../components/TripleColumn.css";

const Services = ({ onOpenModal }) => (
    <div className="section" id="services">
        <Container>
            <Row>
                <Col>
                    <p className="h2">What can we do?</p>
                </Col>
            </Row>
            <Row>

                <CardGroup>
                    <Card className="customCard">
                        <Card.Title>Residential</Card.Title>
                        <Card.Img src={ResidentialImage} />
                        <Card.Body><p className="body-lg">Transform your home with expert window tinting designed to reduce glare, block radiant heat, and protect interiors from sun damage. Our premium films enhance privacy without sacrificing your stunning views, and help lower energy costs year-round. With over 25 years of experience, we ensure flawless application tailored to your home's unique needs.</p></Card.Body>
                        <Button onClick={onOpenModal} > Request an Estimate</Button>
                    </Card>
                    <Card className="customCard">
                        <Card.Title>Business</Card.Title>
                        <Card.Img src={BusinessImage} />
                        <Card.Body><p className="body-lg">Create a more comfortable, energy-efficient workplace with professional tinting solutions for your business. Whether it’s reducing glare in office spaces, enhancing storefront security, or protecting furnishings from fading, our team delivers precise results to meet your operational needs. Let us help you make a lasting impression with tints that combine functionality and style.</p></Card.Body>
                        <Button onClick={onOpenModal} > Request an Estimate</Button>
                    </Card>
                    <Card className="customCard">
                        <Card.Title>Custom</Card.Title>
                        <Card.Img src={CustomImage} />
                        <Card.Body><p className="body-lg">From RVs to skylights and specialty windows, we offer custom tinting solutions for unique projects. Our expertise extends to complex applications, ensuring a seamless fit for every surface. Whether it’s improving privacy on the road or protecting specialty glass, we bring bring our decades of experience to every project, big or small.</p></Card.Body>
                        <Button onClick={onOpenModal} > Request an Estimate</Button>
                    </Card>
                </CardGroup>

            </Row >
        </Container >
    </div >
);

export default Services;


// import Container from "react-bootstrap/Container";
// import Row from "react-bootstrap/Row";
// import Col from "react-bootstrap/Col";
// import Card from "react-bootstrap/Card";
// import Button from "react-bootstrap/Button";
// import ResidentialImage from "../assets/Services_Photo.png";
// import BusinessImage from "../assets/Services_Photo-1.png";
// import CustomImage from "../assets/Services_Photo-2.png";
// import "../components/TripleColumn.css";

// const Services = () => (
//     <div className="section">
//         <Container>
//             <Row
//                 as="div"
//                 className="table 
//                            equal-height-row 
//                            justify-content-center"
//             >
//                 <Col>
//                     <p className="h2">What can we do?</p>
//                 </Col>
//             </Row>
//             <Row xs={1} md={3} as="div" className="table equal-height-row justify-content-center">
//                 <Col className="equal-height-col">
//                     <Card className="wcuCard">
//                         <Card.Title>Residential</Card.Title>
//                         <Card.Img src={ResidentialImage} />
//                         <Card.Body><p className="body-lg">Transform your home with expert window tinting designed to reduce glare, block radiant heat, and protect interiors from sun damage. Our premium films enhance privacy without sacrificing your stunning views, and help lower energy costs year-round. With over 25 years of experience, we ensure flawless application tailored to your home's unique needs.</p></Card.Body>
//                         <Button>Request an Estimate</Button>
//                     </Card>
//                 </Col>
//                 <Col className="equal-height-col">
//                     <Card className="wcuCard">
//                         <Card.Title>Business</Card.Title>
//                         <Card.Img src={BusinessImage} />
//                         <Card.Body><p className="body-lg">Create a more comfortable, energy-efficient workplace with professional tinting solutions for your business. Whether it’s reducing glare in office spaces, enhancing storefront security, or protecting furnishings from fading, our team delivers precise results to meet your operational needs. Let us help you make a lasting impression with tints that combine functionality and style.</p></Card.Body>
//                         <Button>Request an Estimate</Button>
//                     </Card>
//                 </Col>
//                 <Col className="equal-height-col">
//                     <Card className="wcuCard">
//                         <Card.Title>Custom</Card.Title>
//                         <Card.Img src={CustomImage} />
//                         <Card.Body><p className="body-lg">From RVs to skylights and specialty windows, we offer custom tinting solutions for unique projects. Our expertise extends to complex applications, ensuring a seamless fit for every surface. Whether it’s improving privacy on the road or protecting specialty glass, we bring bring our decades of experience to every project, big or small.</p></Card.Body>
//                         <Button>Request an Estimate</Button>
//                     </Card>
//                 </Col>
//             </Row>
//         </Container>
//     </div>
// );

// export default Services;
